import React from "react";

import styles from "./styles.css";
import { useDictionary } from "hooks";

const SubformNotification = ({ sectionLabel, elementLabel }) => {
	const notificationsDictionary = useDictionary("formDesigner.notifications");

	return (
		<React.Fragment>
			<p>{notificationsDictionary.formContainsSubform}</p>
			<ul className={styles.invalidElementsList}>
				<li key={`invalid-field-description-subform`}>
					<div>
						<span>
							<p><strong>Section:</strong> {sectionLabel}</p>
							<p><strong>Question:</strong> {elementLabel}</p>
						</span>
					</div>
				</li>
			</ul>
			<p>{notificationsDictionary.subformNeedsToBeRemoved}</p>
		</React.Fragment>
	);
};

export default SubformNotification;
